<!--
  后台登录页
  用途：输入管理密码后进入数据管理后台
  用法：访问 /#/admin/login ，默认密码见 api/config/config.php（admin123）
-->
<template>
  <div class="login-page">
    <form class="login-card" @submit.prevent="onSubmit">
      <img class="logo" :src="logoUrl" alt="Logo" />
      <h1>数据管理后台</h1>
      <p class="tip">请输入管理密码以继续</p>
      <label>
        <span>密码</span>
        <input v-model="password" type="password" required autocomplete="current-password" />
      </label>
      <button type="submit" :disabled="loading">
        {{ loading ? '登录中…' : '登录' }}
      </button>
      <p v-if="error" class="error">{{ error }}</p>
      <router-link class="back" to="/">← 返回前台网站</router-link>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { loginAdmin } from '@/services/api'
import logoUrl from '@/assets/logo.png'

const route = useRoute()
const router = useRouter()
const password = ref('')
const loading = ref(false)
const error = ref('')

const onSubmit = async () => {
  loading.value = true
  error.value = ''
  try {
    await loginAdmin(password.value)
    const redirect = route.query.redirect || '/admin'
    router.replace(String(redirect))
  } catch (e) {
    error.value = e.message || '登录失败'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top right, rgba(210, 7, 22, 0.12), transparent 40%),
    #f7f7f7;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 32px 28px;
  text-align: left;
}

.logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
  margin-bottom: 14px;
}

h1 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 6px;
}

.tip {
  color: var(--color-text-secondary);
  font-size: 14px;
  margin-bottom: 20px;
}

label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  color: var(--color-text-secondary);
  margin-bottom: 16px;
}

input {
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
}

button {
  width: 100%;
  border: none;
  border-radius: 999px;
  padding: 12px 16px;
  background: var(--color-primary);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

button:disabled {
  opacity: 0.7;
}

.error {
  margin-top: 12px;
  color: var(--color-primary);
  font-size: 13px;
}

.back {
  display: inline-block;
  margin-top: 18px;
  font-size: 13px;
  color: var(--color-text-secondary);
}
</style>
